import request from '@/utils/request'

// 我的工作日志
export function listMyWorkLogs(data) {
  return request({
    url: '/crmWorkLog/myList',
    method: 'post',
    data
  })
}

// 我收到的工作日志
export function listReceivedWorkLogs(data) {
  return request({
    url: '/crmWorkLog/receivedList',
    method: 'post',
    data
  })
}

// 工作日志管理列表
export function listAllWorkLogs(data) {
  return request({
    url: '/crmWorkLog/allList',
    method: 'post',
    data
  })
}

// 工作日志详情
export function getWorkLogDetail(id) {
  return request({
    url: `/crmWorkLog/detail/${id}`,
    method: 'get'
  })
}

// 保存草稿
export function saveWorkLogDraft(data) {
  return request({
    url: '/crmWorkLog/saveDraft',
    method: 'post',
    data
  })
}

// 提交日志
export function submitWorkLog(data) {
  return request({
    url: '/crmWorkLog/submit',
    method: 'post',
    data
  })
}

// 定时发送日志
export function scheduleSubmitWorkLog(data) {
  return request({
    url: '/crmWorkLog/scheduleSubmit',
    method: 'post',
    data
  })
}

// 撤回日志
export function withdrawWorkLog(id) {
  return request({
    url: `/crmWorkLog/withdraw/${id}`,
    method: 'post'
  })
}

// 删除日志
export function removeWorkLog(id) {
  return request({
    url: `/crmWorkLog/remove/${id}`,
    method: 'post'
  })
}

// 评论日志
export function saveWorkLogComment(data) {
  return request({
    url: '/crmWorkLog/comment/save',
    method: 'post',
    data
  })
}

// 追加批注评论
export function saveWorkLogAnnotationReply(data) {
  return request({
    url: '/crmWorkLog/annotation/reply/save',
    method: 'post',
    data
  })
}
